export interface UploadDoiInventoryPolicy {
  [key: string]: any;
  // Common required field
  "Material": string;

  // Portuguese fields
  "Centro"?: string;
  "DOI Alvo"?: string | null;
  "DOI Mínimo"?: string | null;
  "DOI Máximo"?: string | null;
  "Piso de DOI"?: string | null;

  // English fields
  "Unit"?: string;
  "Target DOI"?: string | null;
  "Min DOI"?: string | null;
  "Max DOI"?: string | null;
  "DOI Floor"?: string | null;

  // Spanish fields (Spanish uses "Centro", "DOI Mínimo", "DOI Máximo" and "Piso de DOI" shared with PT-BR;
  // only the target column differs)
  "DOI Objetivo"?: string | null;
}

export const UploadDoiInventoryPolicyPtBrCSVEmpty = {
  "Material": "",
  "Centro": "",
  "DOI Alvo": "",
  "DOI Mínimo": "",
  "DOI Máximo": "",
  "Piso de DOI": "",
};

export const UploadDoiInventoryPolicyEsCSVEmpty = {
  "Material": "",
  "Centro": "",
  "DOI Objetivo": "",
  "DOI Mínimo": "",
  "DOI Máximo": "",
  "Piso de DOI": "",
};

export const UploadDoiInventoryPolicyEnCSVEmpty = {
  "Material": "",
  "Unit": "",
  "Target DOI": "",
  "Min DOI": "",
  "Max DOI": "",
  "DOI Floor": "",
};

export const UploadDoiInventoryPolicyRequiredFieldsPtBr = [
  'Material',
  'Centro',
  'DOI Alvo',
  'DOI Mínimo',
  'DOI Máximo',
  'Piso de DOI'
];

export const UploadDoiInventoryPolicyRequiredFieldsEs = [
  'Material',
  'Centro',
  'DOI Objetivo',
  'DOI Mínimo',
  'DOI Máximo',
  'Piso de DOI'
];

export const UploadDoiInventoryPolicyRequiredFieldsEn = [
  'Material',
  'Unit',
  'Target DOI',
  'Min DOI',
  'Max DOI',
  'DOI Floor'
];
